import {ReceiversService} from '../../libs/ui/src/index';
import {client} from '../apiService';
const _ReceiversService = new ReceiversService({client});
export {_ReceiversService as ReceiversService};
